import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  getFailedDeliveries(campaignId, params = {}) {
    // Garante que campaignId é passado corretamente e params contém paginação
    const fullUrl = `${this.url}/${campaignId}/failed_deliveries`;
    return window.axios.get(fullUrl, { params });
  }

  getDeliveries(campaignId, params = {}) {
    return window.axios.get(`${this.url}/${campaignId}/deliveries`, { params });
  }

  exportDeliveries(campaignId, params = {}) {
    return window.axios.get(`${this.url}/${campaignId}/deliveries.csv`, {
      params,
      responseType: 'text',
    });
  }

  stop(campaignId) {
    return axios.post(`${this.url}/${campaignId}/stop`);
  }

  pause(campaignId) {
    return axios.post(`${this.url}/${campaignId}/pause`);
  }

  resume(campaignId) {
    return axios.post(`${this.url}/${campaignId}/resume`);
  }

  getCampaign(campaignId) {
    return axios.get(`${this.url}/${campaignId}`);
  }

  update(id, data) {
    // Se os dados são FormData, envie com multipart/form-data
    if (data instanceof FormData) {
      return axios.patch(`${this.url}/${id}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }
    // Caso contrário, use o comportamento padrão
    return axios.patch(`${this.url}/${id}`, data);
  }

  // Ciclos de uma campanha recorrente. So `mass_outbound` com
  // `execution_mode = recurring` responde 200; os outros tipos devolvem 422.
  getCycles(campaignId, params = {}) {
    return axios.get(`${this.url}/${campaignId}/cycles`, { params });
  }

  getAuditEvents(campaignId, params = {}) {
    return axios.get(`${this.url}/${campaignId}/audit_events`, { params });
  }
}

export default new CampaignsAPI();
